import { cryptocurrencyAmountTypePolicy, dateTypePolicy } from "../gql/scalars";

export const scalarTypePolicies = {
  Age: { fields: { cutOffDate: dateTypePolicy } },
  AirdropPromotionalEvent: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  AlternativeRewardConfig: { fields: { validUntil: dateTypePolicy } },
  Announcement: { fields: { createdAt: dateTypePolicy } },
  AnnouncementNotification: { fields: { createdAt: dateTypePolicy } },
  AnyPlayerNewsUpdate: { fields: { date: dateTypePolicy } },
  AppearanceBoostShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  ApplePurchaseToken: { fields: { createdAt: dateTypePolicy } },
  AuctionNotification: { fields: { createdAt: dateTypePolicy } },
  AuthorizationRequest: {
    fields: {
      cancelledAt: dateTypePolicy,
      consumedAt: dateTypePolicy,
      createdAt: dateTypePolicy,
      provisionedAt: dateTypePolicy,
      reservedAt: dateTypePolicy,
    },
  },
  AutoClaimNotification: { fields: { createdAt: dateTypePolicy } },
  BankWithdrawal: { fields: { createdAt: dateTypePolicy } },
  BaseWithdrawalAuthorizationRequest: {
    fields: { amount: cryptocurrencyAmountTypePolicy, feeAmount: cryptocurrencyAmountTypePolicy },
  },
  BaseballCard: {
    fields: {
      inSeasonUntil: dateTypePolicy,
      lastLeveledUpAt: dateTypePolicy,
      nextLevelUpAvailableAt: dateTypePolicy,
      ownerSince: dateTypePolicy,
      sealedAt: dateTypePolicy,
      unsealableAt: dateTypePolicy,
      unsealedAt: dateTypePolicy,
    },
  },
  BaseballPlayer: { fields: { birthDay: dateTypePolicy } },
  BidSource: { fields: { date: dateTypePolicy } },
  Blueprint: { fields: { launchDate: dateTypePolicy, revealDate: dateTypePolicy } },
  Card: {
    fields: {
      createdAt: dateTypePolicy,
      inSeasonUntil: dateTypePolicy,
      lastLeveledUpAt: dateTypePolicy,
      nextLevelUpAvailableAt: dateTypePolicy,
      ownerSince: dateTypePolicy,
      sealedAt: dateTypePolicy,
      u23EligibleUntil: dateTypePolicy,
      unsealableAt: dateTypePolicy,
      unsealedAt: dateTypePolicy,
    },
  },
  CardCollectionCard: { fields: { heldSince: dateTypePolicy } },
  CardCollectionNotification: { fields: { createdAt: dateTypePolicy } },
  CardNotification: { fields: { createdAt: dateTypePolicy } },
  CardPack: { fields: { endDate: dateTypePolicy } },
  CardPackGroup: { fields: { nextPackRotationAt: dateTypePolicy } },
  CardPull: { fields: { expiresAt: dateTypePolicy } },
  CardPullSource: { fields: { date: dateTypePolicy } },
  CardSet: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  CardShardThresholdsPromotionalEvent: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  CardSource: { fields: { date: dateTypePolicy } },
  CardsCountTask: { fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy } },
  CartPurchaseRewardPromotionalEvent: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  CommonCardSwapShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  CommonGameEndOfSeasonCountdown: { fields: { countdownUntil: dateTypePolicy } },
  CompleteCollectionsCountTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  ComposeTeamBenchCard: { fields: { lockedAt: dateTypePolicy } },
  ComposeTeamBenchCommonPlayer: { fields: { lockedAt: dateTypePolicy } },
  Config: {
    fields: { ethQuantum: cryptocurrencyAmountTypePolicy, minimumReceiveWeiAmount: cryptocurrencyAmountTypePolicy },
  },
  ConversionCredit: { fields: { endDate: dateTypePolicy } },
  ConversionCreditCampaign: { fields: { endDate: dateTypePolicy } },
  ConversionCreditNotification: { fields: { createdAt: dateTypePolicy } },
  CurrentUser: {
    fields: {
      availableBalance: cryptocurrencyAmountTypePolicy,
      availableBalanceForWithdrawal: cryptocurrencyAmountTypePolicy,
      bankBalance: cryptocurrencyAmountTypePolicy,
      blockedUntil: dateTypePolicy,
      createdAt: dateTypePolicy,
      lastNotificationCreatedAt: dateTypePolicy,
      lastUnreadNotificationCreatedAt: dateTypePolicy,
      matchedContactsAt: dateTypePolicy,
      sorareAddressBalance: cryptocurrencyAmountTypePolicy,
      totalBalance: cryptocurrencyAmountTypePolicy,
    },
  },
  DailyActionTask: { fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy } },
  DateRangeSpecific: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  DecisiveActionNotification: { fields: { createdAt: dateTypePolicy } },
  DecisivePlayerPickerTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  DecisivePlayerPickerTaskAppearance: { fields: { lockedAt: dateTypePolicy } },
  DecisivePurchaseNotification: { fields: { createdAt: dateTypePolicy } },
  DeliverableItemOrder: { fields: { claimedAt: dateTypePolicy, createdAt: dateTypePolicy, expiresAt: dateTypePolicy } },
  DeliverableWithCustomVariantShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  DeliverableWithNoVariantShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  DepositPromotionalEvent: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  DropChallengeTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  EmailSubscription: { fields: { updatedAt: dateTypePolicy } },
  EnglishAuctionSource: { fields: { date: dateTypePolicy } },
  EthDeposit: { fields: { weiAmount: cryptocurrencyAmountTypePolicy } },
  EthereumBankConditionalTransferAuthorizationRequest: {
    fields: {
      amount: cryptocurrencyAmountTypePolicy,
      conditionalAmount: cryptocurrencyAmountTypePolicy,
      feeAmount: cryptocurrencyAmountTypePolicy,
    },
  },
  EthereumBankTransferAuthorizationRequest: {
    fields: { amount: cryptocurrencyAmountTypePolicy, feeAmount: cryptocurrencyAmountTypePolicy },
  },
  EthereumTransaction: { fields: { confirmedAt: dateTypePolicy } },
  ExchangeRate: { fields: { time: dateTypePolicy } },
  ExternalDepositNotification: { fields: { amount: cryptocurrencyAmountTypePolicy, createdAt: dateTypePolicy } },
  ExtraSwapShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  FastWithdrawal: { fields: { createdAt: dateTypePolicy } },
  FastWithdrawalWithRates: { fields: { createdAt: dateTypePolicy } },
  Fee: { fields: { feeLimit: cryptocurrencyAmountTypePolicy } },
  FootballGoalEvent: { fields: { occurredAt: dateTypePolicy } },
  FootballManagerTask: { fields: { claimedAt: dateTypePolicy, readyAt: dateTypePolicy, resetAt: dateTypePolicy } },
  FootballSanctionCardEvent: { fields: { occurredAt: dateTypePolicy } },
  Game: { fields: { date: dateTypePolicy } },
  GameDay: { fields: { date: dateTypePolicy } },
  GameOfBaseball: { fields: { date: dateTypePolicy } },
  GameOfBasketball: { fields: { date: dateTypePolicy } },
  GameWeeklyTask: { fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy } },
  InGameCurrencyNotification: { fields: { createdAt: dateTypePolicy } },
  InGameCurrencySource: { fields: { date: dateTypePolicy } },
  Injury: { fields: { expectedEndDate: dateTypePolicy, startDate: dateTypePolicy } },
  InviteTaskAsReferrer: {
    fields: {
      claimableAt: dateTypePolicy,
      claimedAt: dateTypePolicy,
      completedAt: dateTypePolicy,
      endDate: dateTypePolicy,
    },
  },
  JerseyShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  JwtToken: { fields: { expiredAt: dateTypePolicy } },
  KycRequestNotification: { fields: { createdAt: dateTypePolicy } },
  LevelUpShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  Loan: { fields: { endDate: dateTypePolicy } },
  LoanNotification: { fields: { createdAt: dateTypePolicy, eligibleUntil: dateTypePolicy } },
  LoanableConfigRoot: { fields: { eligibleUntil: dateTypePolicy } },
  LobbyTile: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  ManagerProgressionNotification: { fields: { createdAt: dateTypePolicy } },
  MangopayKycRequest: {
    fields: {
      createdAt: dateTypePolicy,
      outOfDateAt: dateTypePolicy,
      refusedAt: dateTypePolicy,
      validatedAt: dateTypePolicy,
      validationAskedAt: dateTypePolicy,
    },
  },
  MangopayUser: { fields: { dob: dateTypePolicy } },
  MarketPromotionalEvent: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  MarketingNotification: { fields: { createdAt: dateTypePolicy } },
  Membership: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  MissedAppearance: { fields: { lockedAt: dateTypePolicy } },
  MissedLineupNotification: { fields: { createdAt: dateTypePolicy } },
  MonetaryAmount: { fields: { lamport: cryptocurrencyAmountTypePolicy, wei: cryptocurrencyAmountTypePolicy } },
  NBACard: {
    fields: {
      inSeasonUntil: dateTypePolicy,
      lastLeveledUpAt: dateTypePolicy,
      nextLevelUpAvailableAt: dateTypePolicy,
      ownerSince: dateTypePolicy,
      sealedAt: dateTypePolicy,
      unsealableAt: dateTypePolicy,
      unsealedAt: dateTypePolicy,
    },
  },
  NBAPlayer: { fields: { birthDay: dateTypePolicy } },
  NoCardRoute: { fields: { nextCloseDate: dateTypePolicy, nextOpenDate: dateTypePolicy } },
  OAuthAccessToken: { fields: { createdAt: dateTypePolicy, expiresAt: dateTypePolicy } },
  OfferNotification: { fields: { createdAt: dateTypePolicy } },
  OwnedSinceRule: { fields: { from: dateTypePolicy, to: dateTypePolicy } },
  Owner: { fields: { from: dateTypePolicy, settleAt: dateTypePolicy } },
  OwnerWithRates: { fields: { from: dateTypePolicy, settleAt: dateTypePolicy } },
  Pack: { fields: { buyingDate: dateTypePolicy } },
  PackSource: { fields: { date: dateTypePolicy } },
  Passkey: { fields: { createdAt: dateTypePolicy, lastUsedAt: dateTypePolicy } },
  Payment: { fields: { amount: cryptocurrencyAmountTypePolicy, spentAt: dateTypePolicy } },
  PendingDeposit: { fields: { date: dateTypePolicy } },
  PictureFrameShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  Player: { fields: { birthDate: dateTypePolicy, birthDay: dateTypePolicy, u23EligibleUntil: dateTypePolicy } },
  PrimaryOfferSource: { fields: { date: dateTypePolicy } },
  PrintablePlayerSource: { fields: { date: dateTypePolicy } },
  ProbabilisticBundle: { fields: { openableAt: dateTypePolicy, openedAt: dateTypePolicy } },
  ProbabilisticBundleConfig: { fields: { openableAt: dateTypePolicy } },
  ProbabilisticBundleSource: { fields: { date: dateTypePolicy } },
  ProbablePitchersForGameWeek: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  PromotionalEventCompletion: { fields: { expiresAt: dateTypePolicy } },
  PurchasableItemsVoucher: { fields: { endDate: dateTypePolicy } },
  Query: { fields: { cardShardsPoolComputedAt: dateTypePolicy } },
  RaffleShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  Range: { fields: { max: cryptocurrencyAmountTypePolicy, min: cryptocurrencyAmountTypePolicy } },
  Rates: { fields: { lamport: cryptocurrencyAmountTypePolicy } },
  RecommendedConversionCreditTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  Referral: {
    fields: {
      completedAt: dateTypePolicy,
      expirationDate: dateTypePolicy,
      refereeConfirmedAt: dateTypePolicy,
      refereeInvitationSentAt: dateTypePolicy,
    },
  },
  ReferralLeaderboard: { fields: { lastRefreshedAt: dateTypePolicy } },
  ReferralLeaderboardRanking: { fields: { scoreReachedAt: dateTypePolicy } },
  ReferralReward: { fields: { claimableAt: dateTypePolicy } },
  ReferralRewardNotification: { fields: { createdAt: dateTypePolicy } },
  RejectedCraftSource: { fields: { date: dateTypePolicy } },
  ReminderNotification: { fields: { createdAt: dateTypePolicy } },
  SaleNotification: { fields: { createdAt: dateTypePolicy } },
  ShopItem: { fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy } },
  ShopItemNotification: { fields: { createdAt: dateTypePolicy } },
  SignedCardPrice: { fields: { validUntil: dateTypePolicy } },
  SkinShopItem: {
    fields: { createdAt: dateTypePolicy, expirationDate: dateTypePolicy, myLimitResetAt: dateTypePolicy },
  },
  So5Appearance: { fields: { lockedAt: dateTypePolicy } },
  So5Campaign: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  So5Config: { fields: { tasksExpiresAt: dateTypePolicy } },
  So5Fixture: {
    fields: {
      cutOffDate: dateTypePolicy,
      endDate: dateTypePolicy,
      expectedRewardsDistributionDate: dateTypePolicy,
      projectedLineupsReadyAt: dateTypePolicy,
      rewardsDeliveryDate: dateTypePolicy,
      startDate: dateTypePolicy,
    },
  },
  So5FixturePreparing: {
    fields: {
      cutOffDate: dateTypePolicy,
      endDate: dateTypePolicy,
      expectedRewardsDistributionDate: dateTypePolicy,
      startDate: dateTypePolicy,
    },
  },
  So5Leaderboard: {
    fields: {
      cutOffDate: dateTypePolicy,
      endDate: dateTypePolicy,
      projectedLineupsReadyAt: dateTypePolicy,
      startDate: dateTypePolicy,
    },
  },
  So5LeaderboardEntryItemSource: { fields: { date: dateTypePolicy } },
  So5LeaderboardGroup: { fields: { cutOffDate: dateTypePolicy } },
  So5LeaderboardTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  So5League: { fields: { cutOffDate: dateTypePolicy, rewardPoolComputedAt: dateTypePolicy } },
  So5Lineup: { fields: { cancelledAt: dateTypePolicy } },
  So5LineupNotification: { fields: { createdAt: dateTypePolicy } },
  So5OnboardingPromotionalEvent: { fields: { endDate: dateTypePolicy } },
  So5Reward: { fields: { weiAmount: cryptocurrencyAmountTypePolicy } },
  So5RewardSource: { fields: { date: dateTypePolicy } },
  So5UserGroup: { fields: { customEndDate: dateTypePolicy } },
  So5UserGroupMembership: { fields: { createdAt: dateTypePolicy } },
  So5UserGroupNotification: { fields: { createdAt: dateTypePolicy } },
  SolanaBankConditionalTransferAuthorizationRequest: {
    fields: {
      amount: cryptocurrencyAmountTypePolicy,
      conditionalAmount: cryptocurrencyAmountTypePolicy,
      feeAmount: cryptocurrencyAmountTypePolicy,
    },
  },
  SolanaBankTransferAuthorizationRequest: {
    fields: { amount: cryptocurrencyAmountTypePolicy, feeAmount: cryptocurrencyAmountTypePolicy },
  },
  SolanaBankWithdrawalAuthorizationRequest: {
    fields: { amount: cryptocurrencyAmountTypePolicy, feeAmount: cryptocurrencyAmountTypePolicy },
  },
  SortingType: { fields: { readyAt: dateTypePolicy } },
  SpecialEditionPromotionalEvent: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  StarPackTask: {
    fields: {
      claimableAt: dateTypePolicy,
      claimedAt: dateTypePolicy,
      completedAt: dateTypePolicy,
      nextStarPlayerRotationAt: dateTypePolicy,
    },
  },
  StarkexLimitOrderAuthorizationRequest: {
    fields: { amountBuy: cryptocurrencyAmountTypePolicy, amountSell: cryptocurrencyAmountTypePolicy },
  },
  StarkexTransferAuthorizationRequest: { fields: { amount: cryptocurrencyAmountTypePolicy } },
  StarkwarePrivateAccount: {
    fields: {
      availableBalance: cryptocurrencyAmountTypePolicy,
      availableBalanceForWithdrawal: cryptocurrencyAmountTypePolicy,
      totalBalance: cryptocurrencyAmountTypePolicy,
    },
  },
  StartingLineupRevealedActivity: { fields: { createdAt: dateTypePolicy } },
  Story: { fields: { expiresAt: dateTypePolicy } },
  SubstitutionEvent: { fields: { occurredAt: dateTypePolicy } },
  Suspension: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  Task: { fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy } },
  TaskAppearance: { fields: { lockedAt: dateTypePolicy } },
  TaskCampaign: { fields: { endDate: dateTypePolicy } },
  TaskCampaignsHomepageCampaign: { fields: { startDate: dateTypePolicy } },
  TaskLineup: { fields: { cancelledAt: dateTypePolicy } },
  TaskNotification: { fields: { createdAt: dateTypePolicy } },
  TaskSource: { fields: { date: dateTypePolicy } },
  TasksTrack: {
    fields: {
      claimableAt: dateTypePolicy,
      claimedAt: dateTypePolicy,
      completedAt: dateTypePolicy,
      endDate: dateTypePolicy,
    },
  },
  TeamsPlayingNextGameWeek: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  ThresholdPickerTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  ThresholdPickerTaskAppearance: { fields: { lockedAt: dateTypePolicy } },
  ThresholdPickerTaskLineup: { fields: { cancelledAt: dateTypePolicy } },
  ThresholdStreakTaskCurrentThresholdStatus: { fields: { claimableAt: dateTypePolicy } },
  ThresholdsDuoConnectionTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  ThresholdsStreakAdditionalLineupTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  ThresholdsStreakTask: {
    fields: { claimableAt: dateTypePolicy, claimedAt: dateTypePolicy, completedAt: dateTypePolicy },
  },
  TokenAuction: {
    fields: {
      endDate: dateTypePolicy,
      startDate: dateTypePolicy,
      transactionDate: dateTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  TokenBid: { fields: { createdAt: dateTypePolicy } },
  TokenMonetaryReward: { fields: { amount: cryptocurrencyAmountTypePolicy } },
  TokenMyBid: { fields: { createdAt: dateTypePolicy } },
  TokenOffer: {
    fields: {
      acceptedAt: dateTypePolicy,
      cancelledAt: dateTypePolicy,
      createdAt: dateTypePolicy,
      endDate: dateTypePolicy,
      startDate: dateTypePolicy,
      transactionDate: dateTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  TokenOfferSide: { fields: { wei: cryptocurrencyAmountTypePolicy } },
  TokenOwner: { fields: { from: dateTypePolicy, settleAt: dateTypePolicy } },
  TokenPrice: { fields: { date: dateTypePolicy } },
  TokenPrimaryOffer: {
    fields: {
      acceptedAt: dateTypePolicy,
      cancelledAt: dateTypePolicy,
      endDate: dateTypePolicy,
      settledAt: dateTypePolicy,
      startDate: dateTypePolicy,
      transactionDate: dateTypePolicy,
      updatedAt: dateTypePolicy,
    },
  },
  UnknownSource: { fields: { date: dateTypePolicy } },
  User: { fields: { createdAt: dateTypePolicy } },
  UserAccountEntry: { fields: { date: dateTypePolicy } },
  UserAward: { fields: { updatedAt: dateTypePolicy } },
  UserAwardNotification: { fields: { createdAt: dateTypePolicy } },
  UserCardCollection: { fields: { completedAt: dateTypePolicy } },
  UserDevice: { fields: { lastUsedAt: dateTypePolicy } },
  UserDeviceEvent: { fields: { lastUsedAt: dateTypePolicy } },
  UserFlag: { fields: { until: dateTypePolicy } },
  UserGroupCreatedActivity: { fields: { createdAt: dateTypePolicy } },
  UserGroupMemberJoinedActivity: { fields: { createdAt: dateTypePolicy } },
  UserGroupRankedActivity: { fields: { createdAt: dateTypePolicy } },
  UserOwner: { fields: { from: dateTypePolicy, settleAt: dateTypePolicy } },
  UserRelationNotification: { fields: { createdAt: dateTypePolicy } },
  UserWithSubscriptionSlug: { fields: { createdAt: dateTypePolicy } },
  Validity: { fields: { upcomingAt: dateTypePolicy } },
  Watchlist: { fields: { createdAt: dateTypePolicy, updatedAt: dateTypePolicy } },
  WheelConfig: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  Withdrawal: {
    fields: {
      agreedFeeAmount: cryptocurrencyAmountTypePolicy,
      amount: cryptocurrencyAmountTypePolicy,
      createdAt: dateTypePolicy,
    },
  },
  WithdrawalWithRates: {
    fields: {
      agreedFeeAmount: cryptocurrencyAmountTypePolicy,
      amount: cryptocurrencyAmountTypePolicy,
      createdAt: dateTypePolicy,
    },
  },
  XPCooldownPromotionalEvent: { fields: { endDate: dateTypePolicy, startDate: dateTypePolicy } },
  prepareMigrateEthPayload: { fields: { weiAmount: cryptocurrencyAmountTypePolicy } },
};
